import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/Layout";
import { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const PUPPIES = "https://static.prod-images.emergentagent.com/jobs/5eff8c1f-b59e-44ca-87ee-9b0bceebb3f3/images/ff0a9c020904b528920e1501170960f778cde85adb4b8f961427da4aeef5636f.jpeg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) { setError(formatError(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <div className="grid lg:grid-cols-2 min-h-[80vh]">
        <div className="relative hidden lg:block">
          <img src={PUPPIES} alt="E.O.N Boerboel puppies" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-eon-text/80 via-eon-text/20 to-transparent" />
          <div className="relative h-full flex flex-col justify-end p-12 text-white">
            <div className="text-[11px] font-bold tracking-widest uppercase text-white/80 mb-3">Welcome Back</div>
            <h2 className="font-display font-black text-4xl uppercase leading-[0.95]">More Than A Breed.<br />An Entire Ecosystem.</h2>
          </div>
        </div>
        <div className="flex items-center justify-center p-8">
          <div className="w-full max-w-sm">
            <h1 className="eon-heading text-4xl uppercase">Sign In</h1>
            <p className="text-sm text-eon-muted mt-2">Access your dashboard, favorites and orders.</p>
            {error && <div className="mt-4 border border-red-800/50 bg-red-950/30 text-red-300 text-sm px-4 py-3" data-testid="login-error">{error}</div>}
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
              <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-eon-surface border border-eon-border px-4 py-3.5 focus:border-eon-gold outline-none" data-testid="login-email" />
              <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-eon-surface border border-eon-border px-4 py-3.5 focus:border-eon-gold outline-none" data-testid="login-password" />
              <button type="submit" disabled={busy} className="w-full bg-eon-gold text-white font-bold uppercase tracking-wider py-3.5 hover:bg-eon-goldhover transition-colors disabled:opacity-50" data-testid="login-submit">{busy ? "Signing in..." : "Sign In"}</button>
            </form>
            <div className="flex items-center gap-4 my-6"><div className="flex-1 h-px bg-eon-border" /><span className="eon-label">or</span><div className="flex-1 h-px bg-eon-border" /></div>
            <button onClick={google} data-testid="google-login-btn" className="w-full border border-eon-border py-3.5 text-sm font-medium hover:border-eon-gold transition-colors flex items-center justify-center gap-3">
              <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continue with Google
            </button>
            <p className="text-sm text-eon-muted mt-6 text-center">No account? <Link to="/register" className="text-eon-gold">Create one</Link></p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
